import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import StepUpCallbackHandler from './StepUpCallbackHandler';
import { Progress } from '@awesomecomponents/mux';

const StepUpHandler = ({ oidc, logger }) => {
  const handler = new StepUpCallbackHandler();

  const history = useHistory();

  const callbackHandler = async (jwt, sessionCorrelationId, formName, lang) => {
    try {
      await handler.callbackHandler(jwt, sessionCorrelationId, formName, lang);
    } catch (error) {
      // Show 401 error when step up is unsuccessful
      history.push('/app/sde/error');
    }
  };

  useEffect(() => {
    const transactionId = logger.generateGuid();
    oidc.stepUpCallback(callbackHandler, transactionId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oidc]);

  return <Progress />;
};

export default StepUpHandler;
